import { compile } from 'path-to-regexp';
/**
 * Return uri resolved with uri variables.
 * @param uri Uri to compile.
 * @param params Key value object containing uri variables.
 */
export function resolveUri(uri, params, options) {
    const generator = compile(uri, options);
    return generator(params);
}
//# sourceMappingURL=resolveUri.js.map